/* NukkadTales — Product buy page JS (Foxify-safe external asset)
   Reads config from <script type="application/json" id="ntpb-data-{sid}">
   All event handling via addEventListener / delegation — no inline onclick.
*/
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[id^="ntpb-data-"]').forEach(function (el) {
      try { setup(JSON.parse(el.textContent)); } catch (e) { console.error('[ntpb]', e); }
    });
  }

  function setup(cfg) {
    var SID      = cfg.sid;
    var VARIANTS = cfg.variants || [];
    var FEE      = cfg.fee;
    var priceNote = cfg.priceNote || '';
    var pname    = cfg.pname || 'Personalisation';
    var nname    = cfg.nname || 'Note';

    var root     = document.getElementById('ntpb-' + SID); if (!root) return;
    var varInput = document.getElementById('ntpbVarId-'  + SID);
    var priceEl  = document.getElementById('ntpbPrice-'  + SID);
    var addBtn   = document.getElementById('ntpbAdd-'    + SID);
    var addLbl   = document.getElementById('ntpbAddLbl-' + SID);
    var qtyEl    = document.getElementById('ntpbQty-'    + SID);
    var mainImg  = document.getElementById('ntpbMain-'   + SID);
    var pers     = document.getElementById('ntpbPers-'   + SID);
    var persTxt  = document.getElementById('ntpbPersTxt-'  + SID);
    var persProp = document.getElementById('ntpbPersProp-' + SID);
    var noteInp  = document.getElementById('ntpbNote-'   + SID);

    function money(c) {
      try { return '₹' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
      catch (e) { return '₹' + (c / 100); }
    }

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
        opts[parseInt(r.getAttribute('data-pos'), 10) - 1] = r.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return VARIANTS.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function syncVariant() {
      var opts = selectedOptions();
      root.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
        var pick = document.getElementById('ntpbPick-' + SID + '-' + r.getAttribute('data-pos'));
        if (pick) pick.textContent = r.value;
      });
      var v = findVariant(opts);
      if (!v) {
        if (varInput) varInput.value = '';
        if (addBtn) { addBtn.disabled = true; if (addLbl) addLbl.textContent = 'Unavailable'; }
        return;
      }
      if (varInput) varInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLbl) addLbl.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (priceEl) {
        var h = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '')
               + money(v.price) + '<small>' + priceNote + '</small>';
        priceEl.innerHTML = h;
      }
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_1100x$1');
      }
    }

    // Variant radio buttons
    root.querySelectorAll('input[type=radio][name^="ntpb-opt-"]').forEach(function (r) {
      r.addEventListener('change', syncVariant);
    });

    // Note / pers text sync
    if (noteInp) {
      noteInp.addEventListener('input', function () {
        var np = document.getElementById('ntpbNoteProp-' + SID);
        if (np) np.value = noteInp.value;
      });
    }
    if (persTxt) {
      persTxt.addEventListener('input', function () {
        if (persProp && !persProp.disabled) persProp.value = persTxt.value;
      });
    }

    // Click delegation inside the section root
    root.addEventListener('click', function (e) {
      // Thumbnail gallery
      var th = e.target.closest('.pg-th');
      if (th) {
        root.querySelectorAll('.pg-th').forEach(function (t) { t.classList.remove('active'); });
        th.classList.add('active');
        if (mainImg) mainImg.src = th.getAttribute('data-full');
        return;
      }
      // Qty +/-
      var qBtn = e.target.closest('.qty-btn[data-adj]');
      if (qBtn && qtyEl) {
        var d = parseInt(qBtn.getAttribute('data-adj'), 10);
        qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) + d);
        return;
      }
      // Personalisation toggle
      var persTop = e.target.closest('.pers-top');
      if (persTop && pers) {
        var on = pers.classList.toggle('on');
        if (persProp) { persProp.disabled = !on; if (on && persTxt) persProp.value = persTxt.value; }
        if (on && persTxt) setTimeout(function () { persTxt.focus(); }, 120);
        return;
      }
      // Personalisation preview
      var prevBtn = e.target.closest('.pers-preview-btn');
      if (prevBtn) {
        var txt = (persTxt && persTxt.value.trim()) || '';
        if (txt) sessionStorage.setItem('nt_landing_text', txt);
        if (typeof ntOpenSlider === 'function') ntOpenSlider('customise');
        return;
      }
      // Policy modal open
      var polOpen = e.target.closest('[data-polaction="open"]');
      if (polOpen) {
        var pe = document.getElementById(polOpen.getAttribute('data-polid'));
        if (pe) pe.classList.add('open');
        return;
      }
      // Policy modal close button
      var polClose = e.target.closest('[data-polaction="close"]');
      if (polClose) {
        var pe2 = document.getElementById(polClose.getAttribute('data-polid'));
        if (pe2) pe2.classList.remove('open');
        return;
      }
      // Policy overlay backdrop
      var polOv = e.target.closest('[data-polaction="overlay"]');
      if (polOv && e.target === polOv) { polOv.classList.remove('open'); return; }
      // Review scroll link
      var revLink = e.target.closest('[data-revscroll]');
      if (revLink) {
        var j = document.getElementById('shopify-product-reviews')
             || document.querySelector('[data-section-type*=review],[id*=review],[class*=nt-review]');
        if (j) j.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    });

    // Open Shopflo cart drawer
    function openFloCart() {
      var host = (typeof handleFloCartBtn === 'function') ? window
               : (window.parent && window.parent !== window && typeof window.parent.handleFloCartBtn === 'function') ? window.parent : null;
      if (host) host.handleFloCartBtn();
      else document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    // AJAX Add-to-cart
    var form = root.querySelector('.ntpb-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        var persOn = pers && pers.classList.contains('on');
        if (persOn && persTxt && !persTxt.value.trim()) {
          if (pers) pers.classList.add('on');
          if (persTxt) persTxt.focus();
          var pi = persTxt && persTxt.closest('.pers-input');
          if (pi) { pi.style.background = 'rgba(212,84,31,.10)'; setTimeout(function () { pi.style.background = ''; }, 1200); }
          return;
        }
        var qty  = parseInt(qtyEl ? qtyEl.value : 1, 10) || 1;
        var item = { id: parseInt(varInput ? varInput.value : 0, 10), quantity: qty, properties: {} };
        if (persOn && persTxt && persTxt.value.trim()) item.properties[pname] = persTxt.value.trim();
        if (noteInp && noteInp.value.trim()) item.properties[nname] = noteInp.value.trim();
        var items = [item];
        if (persOn && FEE && String(FEE).length) items.push({ id: parseInt(FEE, 10), quantity: qty });
        var prev = addLbl ? addLbl.textContent : 'Add to cart';
        if (addBtn) addBtn.disabled = true;
        if (addLbl) addLbl.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (addBtn) addBtn.disabled = false;
            if (addLbl) addLbl.textContent = prev;
            openFloCart();
          })
          .catch(function () {
            if (addBtn) addBtn.disabled = false;
            if (addLbl) addLbl.textContent = prev;
            window.location.href = '/cart';
          });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
